import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { LOGAPIDATA } from "../../../services/ApiCalls";
import { exportCsvHandler } from "../../../utilities/utilities";
import FeatureCard from "./components/FeatureCard";
import { useTranslation } from "react-i18next";
import TableLayout from "../../../components/TableLayout";
import CustomPagination from "../../../components/Common/CustomPagination";
import dataHandler from "../../../hooks/dataHandler";
import moment from "moment";
import { activeInactiveOptions } from "../../../utilities/const";
import LogFilter from "../../../components/Common/LogFilter";
import ButtonLoader from "../../../components/Common/ButtonLoader";

const Log = () => {
  const [exportLoader, setExportLoader] = useState();
  const filterKeys = ["module", "action"];
  const {
    setBody,
    body,
    data,
    statusChangeHandler,
    loader,
    deleteModel,
    setDeleteModel,
    paginationHandler,
    searchHandler,
    total,
    deleteHandler,
  } = dataHandler({
    api: LOGAPIDATA,
    depenendencyArr: filterKeys,
  });
  const { t } = useTranslation();
  const logColumns = [
    {
      head: t("logManagement.columns.serialNumber"),
      accessor: "#",
      component: (item, key) => <>{body.limit * (body.page - 1) + key + 1}</>,
    },
    {
      head: t("logManagement.columns.email"),
      accessor: "email",
      component: (item) => (
        <span
          className="d-inline-block text-truncate"
          title={item.email}
          style={{
            maxWidth: "200px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {item.email || "-"}
        </span>
      ),
    },
    // {
    //   head: "Role",
    //   accessor: "role",
    //   component: (item) => (
    //     <span className="text-capitalize">{item.role || "-"}</span>
    //   ),
    // },
    {
      head: t("logManagement.columns.action"),
      accessor: "action",
      component: (item) => <span>{item.action || "-"}</span>,
    },
    {
      head: t("logManagement.columns.module"),
      accessor: "module",
      component: (item) => <span>{item.module || "-"}</span>,
    },
    {
      head: t("logManagement.columns.details"),
      accessor: "details",
      component: (item) => (
        <span
          className="text-truncate d-inline-block"
          style={{ maxWidth: "150px" }}
          title={item.details}
        >
          {item.details || "-"}
        </span>
      ),
    },
    {
      head: t("logManagement.columns.ipAddress"),
      accessor: "ipAddress",
      component: (item) => <span>{item.ipAddress || "-"}</span>,
    },
    // {
    //   head: "Notes",
    //   accessor: "notes",
    //   component: (item) => <span>{item.notes || "-"}</span>,
    // },
    {
      head: t("logManagement.columns.createdAt"),
      accessor: "createdAt",
      component: (item) => (
        <span>
          {item.createdAt
            ? moment(item.createdAt).format("DD-MM-YYYY, HH:mm")
            : "-"}
        </span>
      ),
    },
    // {
    //   head: "Updated At",
    //   accessor: "updatedAt",
    //   component: (item) => (
    //     <span>
    //       {item.updatedAt
    //         ? moment(item.updatedAt).format("DD-MM-YYYY, HH:mm")
    //         : "-"}
    //     </span>
    //   ),
    // },
  ];

  return (
    <>
      <section className="position-relative py-2">
        <Container>
          <Row>
            <Col lg="12">
              <div className="d-flex justify-content-between">
                <h4 className="mb-0 fw-bold text-dark">{t("logManagement.title")}</h4>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <FeatureCard dashboardData={data?.auditRecords} />
              <Col lg="12" className="my-2">
                <div className="tableFilter d-flex align-items-end justify-content-between flex-wrap gap-10 mb-3">
                  <div className="left">
                    <LogFilter
                      body={body}
                      searchHandler={searchHandler}
                      setBody={setBody}
                      statusFilterOptionArr={activeInactiveOptions}
                    />
                  </div>
                  <div className="d-flex gap-3 flex-wrap">
                    <div className="right">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10 flex-wrap">
                        <li className="">
                          <Button
                            className="d-flex align-items-center justify-content-center fw-sbold commonBtn GreyBtn"
                            style={{ height: 40, minWidth: 100, fontSize: 12 }}
                            type="button"
                            onClick={() =>
                              exportCsvHandler("Log", setExportLoader)
                            }
                          >
                            {exportLoader ? (
                              <ButtonLoader />
                            ) : (
                              t("logManagement.buttons.exportCsv")
                            )}
                          </Button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </Col>
              <Col lg="12" className="my-2">
                <TableLayout
                  column={logColumns}
                  data={data?.resData}
                  loader={loader}
                />
                <CustomPagination
                  total={total}
                  pageChangeHandler={paginationHandler}
                  body={body}
                  setBody={setBody}
                />
              </Col>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Log;
